import {FieldWrapper} from "@progress/kendo-react-form"
import {Label} from "@progress/kendo-react-labels"
import {FieldRenderProps} from "@progress/kendo-react-form"
import {useAppDispatch, useAppSelector} from "../../store"
import {setUserDefaultDealers} from "../../containers/App/appSlice"
import {RootState} from "../../rootReducer"
import React, {useEffect, useState} from "react"
import {DropDownList, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns"
const DealerDropdown = (fieldRenderProps: FieldRenderProps): JSX.Element => {
    const {id, label, valid, editorDisabled, value, onChange} = fieldRenderProps

    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const dispatch = useAppDispatch()
    const [selected, setDealerState] = useState(selectedDealer)

    useEffect(() => {
        setDealerState(selectedDealer)
    }, [selectedDealer])

    const editorRef = React.useRef(null)
    const labelId = label ? `${id}_label` : ""

    const onValueChange = React.useCallback(
        (e: DropDownListChangeEvent) => {
            if (e.value.id) {
                dispatch(setUserDefaultDealers("SINGLE_DEALER", parseInt(e.value.id)))
                onChange({value: e.value.id})
            }
        },
        [onChange, value],
    )

    let data: any[] | undefined = []
    if (userDealers.length > 0) {
        data = userDealers.map(item => {
            return {label: item.dealerName, id: item.dealerId.toString()}
        })
    }
    return (
        <FieldWrapper>
            <Label
                className="questionText"
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={editorDisabled}
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: label,
                    }}
                ></span>
            </Label>
            <div className={"k-form-field-wrap"}>
                <DropDownList
                    value={data.find(t => t.id === selected?.dealerId.toString())}
                    onChange={onValueChange}
                    textField="label"
                    dataItemKey="id"
                    data={data}
                />
            </div>
        </FieldWrapper>
    )
}

export default DealerDropdown
// #endregion
